import { Badge } from "antd";

const PodsStats = ({ runningPods, pendingPods, failedPods }: {
    runningPods: number,
    pendingPods: number,
    failedPods: number
}) => {
    const style = {
        fontSize: 12
    };

    return (
        <>
            {
                !!runningPods &&
                <Badge
                    color="green"
                    text={
                        <span style={style}>
                            {`${runningPods} running ${runningPods === 1 ? "pod" : "pods"}`}
                        </span>
                    }
                />
            }
            {
                !!pendingPods &&
                <Badge
                    color="blue"
                    text={
                        <span style={style}>
                            {`${pendingPods} pending ${pendingPods === 1 ? "pod" : "pods"}`}
                        </span>
                    }
                />
            }
            {
                !!failedPods &&
                <Badge
                    color="red"
                    text={
                        <span style={style}>
                            {`${failedPods} failed ${failedPods === 1 ? "pod" : "pods"}`}
                        </span>
                    }
                />
            }
        </>
    )
}

export default PodsStats;